import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	renderingFailed: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rendering-failed',
		defaultMessage: 'Internal error. {linkStart}Resend the invite{linkEnd} later.',
		description: 'description of this type of error',
	},
	requestTooLong: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-too-long',
		defaultMessage:
			'Notification size is greater than 6 MB. Reduce the size of customer invite template.',
		description: 'description of this type of error',
	},
	emailValidationFailure: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-validation-failure',
		defaultMessage:
			'Unable to validate recipient’s email address. Check the format and invite again.',
		description: 'description of this type of error',
	},
	rfc1918LanIpRoutingFailure: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rfc-1918-lan-ip-routing-failure',
		defaultMessage:
			'Recipient’s email address belongs to a private address space. Invite again using the correct email address.',
		description: 'description of this type of error',
	},
	suppressedMessage: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message',
		defaultMessage:
			'Recipient’s email address is on a suppression list. Resend invite from the {linkStart}Customers page{linkEnd}.',
		description: 'description of this type of error when un-suppression feature is enabled',
	},
	suppressedInviteMessage: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-invite-message',
		defaultMessage:
			'Invite blocked. Resend the invite from the {linkStart}Customers page{linkEnd}.',
		description:
			'Error description reflected in details column of CN logs when a customer invite mail is suppressed',
	},
	suppressedMessageForRequestNotifications: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message-for-request-notifications',
		defaultMessage: 'Recipient’s email address is on a suppression list.',
		description: 'description of this type of error when un-suppression feature is disabled',
	},
	bounced: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.bounced',
		defaultMessage: 'Error from email provider',
		description: 'description of this type of error',
	},
	emailNotificationLimitReached: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-notification-limit-reached',
		defaultMessage: 'Reached the email notifications limit for {siteUrl}.',
		description: 'description of this type of error',
	},
	defaultErrorMessage: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message',
		defaultMessage: 'An unknown error occurred. Try again later.',
		description: 'description of this type of error',
	},
	defaultErrorMessageForRequestNotification: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message-for-request-notification',
		defaultMessage: 'An unknown error occurred.',
		description: 'description of this type of error',
	},
	tableHeaderDateTime: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-date-time',
		defaultMessage: 'Date and time',
		description: 'title of the column header',
	},
	tableHeaderNotificationName: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-notification-name',
		defaultMessage: 'Notification name',
		description: 'title of the column header',
	},
	tableHeaderCustomerEmail: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-customer-email',
		defaultMessage: 'Recipient',
		description: 'title of the column header',
	},
	tableHeaderErrorMessage: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-error-message',
		defaultMessage: 'Details',
		description: 'title of the column header',
	},
	ticketKey: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.ticket-key',
		defaultMessage: 'Issue key',
		description: 'title of the column header',
	},
	ticketKeyIssueTermRefresh: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.ticket-key-issue-term-refresh',
		defaultMessage: 'Work item key',
		description: 'title of the column header',
	},
	customerInvited: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-invited',
		defaultMessage: 'Customer invited',
		description: 'a type of customer notification name',
	},
	requestCreated: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-created',
		defaultMessage: 'Request created',
		description: 'a type of customer notification name',
	},
	publicCommentAdded: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-added',
		defaultMessage: 'Public comment added',
		description: 'a type of customer notification name',
	},
	publicCommentEdited: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-edited',
		defaultMessage: 'Public comment edited',
		description: 'a type of customer notification name',
	},
	requestResolved: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-resolved',
		defaultMessage: 'Request resolved',
		description: 'a type of customer notification name',
	},
	requestReopened: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-reopened',
		defaultMessage: 'Request reopened',
		description: 'a type of customer notification name',
	},
	participantAdded: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.participant-added',
		defaultMessage: 'Participant added',
		description: 'a type of customer notification name',
	},
	organizationAdded: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.organization-added',
		defaultMessage: 'Organization added',
		description: 'a type of customer notification name',
	},
	approvalRequired: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.approval-required',
		defaultMessage: 'Approval required',
		description: 'a type of customer notification name',
	},
	customerVisibleStatusChanged: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-visible-status-changed',
		defaultMessage: 'Customer-visible status changed',
		description: 'a type of customer notification name',
	},
	customNotification: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.custom-notification',
		defaultMessage: 'Custom notification',
		description: 'a type of customer notification name',
	},
	loadMoreLogs: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.load-more-logs',
		defaultMessage: 'Loading more logs...',
		description: 'text to show more rows to be fetched',
	},
	emailBlockedText: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-blocked-text',
		defaultMessage: 'Email blocked.',
		description:
			'Text shown before the unblock email address text button in details tab for request notifications in customer notification logs page in case the email is on suppression list',
	},
	emailUnsuppressBtnLabel: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-unsuppress-btn-label',
		defaultMessage: 'Unblock email address',
		description:
			'Label for the button shown in details tab for request notifications in customer notification logs page in case the email is on suppression list to unblock the email',
	},
	emailUnblockSuccess: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-unblock-success',
		defaultMessage: 'Email was blocked. Unblocked at {actionTakenTime}.',
		description:
			'Text shown after the email is unblocked in details tab for request notifications in customer notification logs page',
	},
	emailSuccessFlagHeading: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-success-flag-heading',
		defaultMessage: 'Unblocking email address',
		description:
			'Success flag heading shown after the email is unblocked in details tab for request notifications in customer notification logs page',
	},
	emailSuccessFlagDescription: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-success-flag-description',
		defaultMessage:
			'It may take a few minutes to complete this action. Undelivered notifications will not be resent.',
		description:
			'Success flag description shown after the email is unblocked in details tab for request notifications in customer notification logs page',
	},
	emailErrorFlagHeading: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-error-flag-heading',
		defaultMessage: 'We’re unable to unblock email address',
		description:
			'Error flag heading shown if there is failure in unblocking email from details tab for request notifications in customer notification logs page',
	},
	emailErrorFlagDescription: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-error-flag-description',
		defaultMessage: 'Try again in a few minutes.',
		description:
			'Error flag description shown if there is failure in unblocking email from details tab for request notifications in customer notification logs page',
	},
});
